import VueRouter from 'vue-router';
// Pages
import Developer from './components/landing-pages/Developer';
import Contact from './components/other-pages/contact/Contact';

export const router = new VueRouter({
	mode: 'history',
	linkExactActiveClass: 'active',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{ path: '/', component: Developer },
		{ path: '/contact', component: Contact }
	]
});
